import React from 'react';

import { getOptionMeta, StepSelectorOption } from './stepConfig';

interface OptionMetaRowProps {
  option: StepSelectorOption;
}

const OptionMetaRow: React.FC<OptionMetaRowProps> = ({ option }) => {
  const { labels, tag } = getOptionMeta(option);

  if (labels.length === 0 && !tag) return null;

  return (
    <div className="mt-0.5 flex flex-wrap items-center gap-x-1 text-sm font-medium text-gray-muted">
      {labels.map((label, index) => (
        <React.Fragment key={label}>
          {index > 0 && <span>|</span>}
          <span>{label}</span>
        </React.Fragment>
      ))}
      {tag && (
        <>
          {labels.length > 0 && <span>|</span>}
          <span className="rounded bg-gray-smoke px-1">{tag.tag}</span>
          <span>{tag.name}</span>
        </>
      )}
    </div>
  );
};

export default OptionMetaRow;
